
import { VFooter } from "vuetify/lib";

export default VFooter.extend({});
